import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import useEvent from "../../../hooks/useEvent";
import "./EmptyState.css";

/**
 * Compact empty state for mobile - fits in collapsed bottom sheet (~200px)
 * Shows contextual message and action buttons in a card-like format
 */
const EmptyState = ({
  token,
  mapCenter,
  onAdHocSearch,
  adHocSearchActive,
}) => {
  const { event } = useEvent();

  return (
    <div className="mobile-empty-state">
      <div className="mobile-empty-state-card">
        <div className="mobile-empty-state-header">
          <i className="fas fa-utensils mobile-empty-state-icon" />
          <div className="mobile-empty-state-text">
            <h3 className="mobile-empty-state-title">No restaurants found</h3>
            <p className="mobile-empty-state-message">
              {event
                ? "No results for this event area"
                : "Try adjusting filters or location"}
            </p>
          </div>
        </div>

        <div className="mobile-empty-state-actions">
          {event ? (
            mapCenter?.lat && mapCenter?.lng && (
              <Link
                to={`/?lat=${mapCenter.lat}&lng=${mapCenter.lng}`}
                className="mobile-empty-state-btn mobile-empty-state-btn-primary"
              >
                <i className="fas fa-search" />
                <span>Search All</span>
              </Link>
            )
          ) : token ? (
            <>
              <Link
                to="/?create=true"
                className="mobile-empty-state-btn mobile-empty-state-btn-primary"
              >
                <i className="fas fa-plus" />
                <span>Add Restaurant</span>
              </Link>
              {onAdHocSearch && (
                <button
                  type="button"
                  onClick={onAdHocSearch}
                  className="mobile-empty-state-btn mobile-empty-state-btn-secondary"
                  disabled={adHocSearchActive}
                >
                  <i className="fas fa-magic" />
                  <span>Discover</span>
                </button>
              )}
            </>
          ) : (
            <Link
              to="/signup"
              className="mobile-empty-state-btn mobile-empty-state-btn-primary"
            >
              <i className="fas fa-user-plus" />
              <span>Sign Up to Add</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  token: PropTypes.string,
  mapCenter: PropTypes.object,
  onAdHocSearch: PropTypes.func,
  adHocSearchActive: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
  mapCenter: state.mapCenter,
  adHocSearchActive: state.restaurant.adHocSearchActive,
});

export default connect(mapStateToProps)(EmptyState);
